
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"28","height":"28","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":".5","y":".884","width":"27","height":"27","rx":"3.5","fill":"none","stroke":"currentColor"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      